import { type ReactNode, createContext, useContext, useState } from 'react'

interface LayoutContextType {
  title: string
  subTitle: string
  setHeader: (title: string, subTitle: string) => void
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined)

export const useLayout = () => {
  const context = useContext(LayoutContext)
  if (!context) {
    throw new Error('useLayout must be used within LayoutProvider')
  }
  return context
}

interface LayoutProviderProps {
  children: ReactNode
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  const [title, setTitle] = useState('CampaignDetailsPage')
  const [subTitle, setSubTitle] = useState('')

  const setHeader = (newTitle: string, newSubTitle: string) => {
    setTitle(newTitle)
    setSubTitle(newSubTitle)
  }

  return <LayoutContext.Provider value={{ title, subTitle, setHeader }}>{children}</LayoutContext.Provider>
}
